import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Container, Grid } from '@material-ui/core';
import Page from 'src/components/Page';
import CpuUsage from './CpuUsage';
import CpuUtilization from './CpuUtilization';
import DiskUtilization from './DiskUtilization';
import MemoryUtilization from './MemoryUtilization';
import MemoryUsage from './MemoryUsage';

import { getPerformanceMetrics } from 'src/actions';

const useStyles = makeStyles(theme => ({
  root: {
    width: '90%',
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  chart: {
    marginBottom: theme.spacing(2)
  },
  chartContainer: {
    height: 320
  },
  lineChartContainer: {
    height: 340
  },
  grid: {
    marginTop: theme.spacing(2)
  }
}));

function DashboardDefault() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { cpuUsage, memoryUsage, performanceMetrics } = useSelector(
    state => state.performanceMetrics
  );
  const { adminConfig } = useSelector(state => state.systemConfig);

  // Set the value of enableDashboardMetrics to true if it is not set in the adminConfig
  // otherwise use the value from the adminConfig
  const enableDashboardMetrics =
    adminConfig.enableDashboardMetrics === undefined
      ? true
      : adminConfig.enableDashboardMetrics;
  useEffect(() => {
    if (enableDashboardMetrics) {
      const interval = setInterval(function() {
        dispatch(getPerformanceMetrics());
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [enableDashboardMetrics, dispatch]);

  // console.log('DashboardDefault has: ' + JSON.stringify(performanceMetrics));
  return (
    <Page className={classes.root} title="Default Dashboard ">
      <Container maxWidth={false}>
        {enableDashboardMetrics && Object.keys(performanceMetrics).length > 0 && (
          <Grid container spacing={3} className={classes.grid}>
            <Grid item lg={4} xs={12}>
              <CpuUtilization data={performanceMetrics} classes={classes} />
            </Grid>
            <Grid item lg={4} xs={12}>
              <MemoryUtilization data={performanceMetrics} classes={classes} />
            </Grid>
            <Grid item lg={4} xs={12}>
              <DiskUtilization data={performanceMetrics} classes={classes} />
            </Grid>
            <Grid item lg={12} xs={12}>
              <MemoryUsage
                data={performanceMetrics}
                samples={memoryUsage}
                classes={classes}
              />
            </Grid>
            <Grid item lg={12} xs={12}>
              <CpuUsage
                data={performanceMetrics}
                samples={cpuUsage}
                classes={classes}
              />
            </Grid>
          </Grid>
        )}
      </Container>
    </Page>
  );
}

export default DashboardDefault;
